export default {
  scorecard: {
    title: '得分卡',
    content: '内容',
    award: 'ESG奖项',
  },
  list_table_filter: {
    table_buyer_company_name: '委托评估公司',
    table_question_group_name: '调查表',
    table_status: '状态',
    table_issue_at: '发布日',
    table_sustaina_rate: 'ESG评级',
    table_esg_score: 'ESG得分',
    table_operation: '操作',
    displayed_items_number: '显示 {total} 个中 {start}〜{end}  个',
    displayed_items_number_empty: '显示 0 个中 0 个',
    no_data_display: '没有可显示的数据。',
    csv_modal_title: '请选择CSV输出内容',
    csv_modal_answer_status_title: '回答情况',
    csv_modal_answer_status_text: '以列表形式输出被评估企业的回答情况。',
    csv_modal_answer_title: '答案（每500家公司一份文件）',
    csv_modal_answer_title_by_individual_company: '答案（每家公司一份文件）',
    csv_modal_answer_text: '以每500家公司一份文件的格式输出被评估企业的回答内容。',
    csv_modal_answer_text_by_individual_company: '以每家公司一份文件的格式输出被评估企业的回答内容。',
    csv_modal_score_title: '得分',
    csv_modal_score_text: '以列表形式输出被评估公司的评级和得分。',
    csv_modal_answer_heading: '标题行',
    csv_modal_answer_heading_supplier: '被评估企业',
    csv_modal_answer_heading_question: '问题',
    csv_modal_answer_additional: '附加项目',
    csv_modal_answer_additional_note: '备注',
    csv_modal_answer_additional_file: '附件名称',
    csv_modal_cautionary_note_title: '注意事项',
    csv_modal_cautionary_note_content: '・{questionGroupName}的回答情况、答案和得分将被输出。\n・无论问卷/调查的回答状态如何，全部被评估企业的回答情况将被输出。\n・问卷/调查的回答状态为“未回答”的被评估企业，其答案和得分将不会被输出。\n・关于答案和得分，一个CSV文件中显示的公司数上限为1,000家。\n・汇总答案和得分的CSV文件将发送到当前登录帐户的电子邮件地址。',
    csv_modal_sent_mail_section_one: '您的 CSV 输出请求已被接受。',
    csv_modal_sent_mail_section_two: 'CSV 下载 URL 将发送到您的电子邮件地址，请稍等片刻。',
    csv_modal_sent_mail_section_three: '如果您在 30 分钟内没有收到电子邮件，请重试。',
  },
  overall_score_section: {
    card_title: '调查内容',
    score: '得分',
    esg_score: 'ESG得分',
    esg_rating: 'ESG评级',
    esg_score_tip: 'ESG 得分是一个数值，用于对贵公司的 ESG 举措进行评估打分。它是根据您对 ASUENE ESG 问卷/调查的回答内容计算得出的。',
    esg_rating_tip: 'ESG 评级是对贵公司 ESG 工作水平的绝对评估。根据 ESG 得分分为 AAA～CCC 7个等级。.',
    evaluator_advice_title: '评估意见',
    list_header_buyer_company_name: '委托评估公司',
    list_header_supplier_company_name: '被评估企业',
    list_header_question: '@:common.upload.title',
    list_header_create_at: '发布日',
    list_header_deadline: '有限期至',
    list_header_industry: '行业',
    list_header_company_scale: '员工人数',
    download_csv: 'CSV 输出',
    download_pdf: 'PDF 输出',
    csv_title_for_buyer: 'ASUENE ESG调查表回答',
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: '答案将以CSV格式下载',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: '答案将以PDF格式下载',
    scorecard_pdf: '得分卡(PDF)',
    download_scorecard_pdf_description: '得分将以PDF格式下载',
    feedback: '评估反馈',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: '文档将以PDF格式下载',
    award_medal_svg: 'ESG奖项(SVG)',
    download_award_medal_svg_description: '将下载SVG图像',
    award_medal_png: 'ESG奖项(PNG)',
    download_award_medal_png_description: '将下载PNG图像',
    pdf_modal_sent_mail_section_one: '您的 PDF 输出请求已被接受。',
    pdf_modal_sent_mail_section_two: 'PDF 下载 URL 将发送到您的电子邮件地址，请稍等片刻。',
    pdf_modal_sent_mail_section_three: '如果您在 30 分钟内没有收到电子邮件，请重试。',
  },
  category_score_section: {
    card_title: '按类别得分',
    tip: '按类别得分是指贵公司在环境、社会和管理方面的得分。每个类别中问题的权重因公司而异。',
    policy: '规范·方针',
    action: '措施',
    result: '结果',
  },
  score_by_category_compared_section: {
    card_title: '按类别比较得分',
    get_score_by_category: '已获得的按类别得分',
    esg_evaluated_all_companies_average: '已进行ASUENE ESG评估的所有公司',
    tip: '这是回答同一问卷/调查的公司的平均得分。由于只是目前的平均值，因此数字可能会有变动。',
  },
  strengths_advice_section: {
    card_title: '评估点·建议',
    strong_point: '评估点',
    advice: '改善点',
    policies: '规范·方针',
    action: '措施',
    result: '结果',
    no_results_for_this_category: '没有可显示的关于该类别的结果。',
    risk: '风险',
    indicator: '指标',
    content: '内容',
    operation: '操作',
  },
  preview: {
    go_back_to_scorecard: '返回得分卡',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: '总分一览',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: '平均分:',
    category_card_score_no_score: '对象之外',
    category_card_score_earned_score: '已得分',
    category_card_details_list_title: '评估意见',
    category_card_details_no_score_tip: '此类别不在评估范围内。',
    category_card_score_average_score: '其他公司平均得分',
    category_card_details_title: '按类别得分一览',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: '该项目不在评估范围内，因为它是使用委托评估公司制定的评估逻辑来进行评分。',
    buyer_evaluate_tip: '使用委托评估公司制定的评估逻辑来进行评分。未使用Asuene ESG的评估逻辑来进行评分。',
    answer_rejection_notification: '您收到了公司的撤回请求',
    answer_rejection_modal_title: '驳回答复',
    answer_rejection_modal_text: '驳回评论',
    answer_rejection_modal_content: '驳回{companyName}的答复。\n请在下面输入给负责人的驳回评论并发送。',
    answer_rejection_dialog_content: '{companyName}的答复已驳回。',
    answer_rejection_button_title: '驳回',
  },
}
